import Created from './Created';
import Updated from './Updated';
import Id from './Id';
import CreatorUser from './CreatorUser';
import Deadline from './Deadline'
import DocketBook from './DocketBook'
import DocumentType from './DocumentType'
import ExtraFields from './ExtraFields'
import From from './From';
import To from './To';
import ReferenceNumber from './ReferenceNumber';
import RelatedDocket from './RelatedDocket';
import ResponsibleUser from './ResponsibleUser';
import ResponsibleUserDeadline from './ResponsibleUserDeadline';
import Type from './Type';
import DocketNumber from './DocketNumber';

export const labels = {
  Id: 'Id',
  CreatorUser: 'Rögzítette',
  DocketNumber: 'Iktató szám',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  Deadline: 'Dátum',
  DocketBook: 'Iktatókönyv',
  DocumentType: 'Irattípus',
  ExtraFields: 'Egyéb adatok',
  From: 'Honnan',
  To: 'Hova',
  ReferenceNumber: 'Hivatkozási szám',
  RelatedDocket: 'Előzmény',
  ResponsibleUser: 'Felelős',
  ResponsibleUserDeadline: 'Felelős határideje',
  Type: 'Irány',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'CreatorUser',
  fixed: true,
}, {
  value: 'DocketNumber',
  fixed: true,
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Deadline',
}, {
  value: 'DocketBook',
}, {
  value: 'DocumentType',
}, {
  value: 'ExtraFields',
}, {
  value: 'From',
}, {
  value: 'To',
}, {
  value: 'ReferenceNumber',
}, {
  value: 'RelatedDocket',
}, {
  value: 'ResponsibleUser',
}, {
  value: 'ResponsibleUserDeadline',
}, {
  value: 'Type',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'DocketNumber',
  fixed: true,
}, {
  value: 'DocketBook',
}, {
  value: 'Type',
}, {
  value: 'CreatorUser',
}, {
  value: 'Created',
}, {
  value: 'From',
}, {
  value: 'To',
}, {
  value: 'DocumentType',
}, {
  value: 'ReferenceNumber',
}, {
  value: 'ResponsibleUser',
}, {
  value: 'ResponsibleUserDeadline',
}, {
  value: 'Deadline',
}, {
  value: 'ExtraFields',
}, {
  value: 'RelatedDocket',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'descending'
};

export default {
  CreatorUser,
  DocketNumber,
  Updated,
  Created,
  Id,
  Deadline,
  DocketBook,
  DocumentType,
  ExtraFields,
  From,
  To,
  ReferenceNumber,
  RelatedDocket,
  ResponsibleUser,
  ResponsibleUserDeadline,
  Type,
};
